/*  NPM  */
import axios from 'axios';
import i18n from 'i18n';

/*  React  */
import { useCallback, useState } from 'react';

const { t } = i18n;

export const usePutStartAnmTrial = ({ platformTenantId }) => {
    const [saving, setSaving] = useState(false);

    const putStartAnmTrial = useCallback(
        async (marketingParams = {}) => {
            setSaving(true);

            let response;
            try {
                const params = { marketingParams, platformTenantId };
                response = await axios.put('/anm/trial', params);
            } catch (err) {
                setSaving(false);
                const errMsg = err?.data?.message || t('Common.error');

                throw new Error(errMsg);
            }

            setSaving(false);

            return response;
        },
        [platformTenantId]
    );

    return { putStartAnmTrial, saving };
};
